import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DailyDashboardPage } from '@/features/attendance/pages/DailyDashboardPage';
import { dailyDashboardSearchSchema } from '@/features/attendance/types/attendance.types';

export const Route = createFileRoute('/_auth/attendance/')({
  validateSearch: dailyDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Daily Attendance">
      <Suspense fallback={<PageLoader />}>
        <DailyDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
